import { accountFormToLicenceQuery } from './accountFormToQuery';
import { accountFormToAccountQuery } from './accountFormToAccountQuery';
import { accountQueryToForm } from './accountQueryToForm';
 
export default {
  formToLicenceQuery: accountFormToLicenceQuery,
  formToAccountQuery: accountFormToAccountQuery,
  queryToForm: accountQueryToForm,
}; 